import React, { ReactElement } from "react";

import classNames from "classnames";

import { topicCSS, topicWithDescriptionCSS } from "./ChatTopic.style";
import { ChatTopicProps } from "./ChatTopic.types";

export const ChatTopic = ({
  children,
  description,
  className,
  ...rest
}: ChatTopicProps): ReactElement => {
  return (
    <button
      {...rest}
      className={classNames(
        topicCSS,
        {
          [topicWithDescriptionCSS]: description,
        },
        className
      )}
      type="button"
    >
      {children}
      {description && <div className="topic-description">{description}</div>}
    </button>
  );
};
